// Configuración base de la API
export const API_CONFIG = {
  /* baseURL: 'http://127.0.0.1:3314/apiHope', */
  baseURL: import.meta.env.VITE_API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
};

// Endpoints de la API
export const API_ENDPOINTS = {
  // Autenticación
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    logout: '/auth/logout',
    forgotPassword: '/auth/forgot-password',
    resetPassword: '/auth/reset-password',
  },

  // Médicos
  medico: {
    dashboard: '/medico/dashboard',
    agenda: '/medico/agenda',
    configurarHorarios: '/medico/agenda/configurar',
    bloquearHorario: '/medico/agenda/bloquear',
    eliminarBloqueo: '/medico/agenda/bloqueo',
    citas: '/medico/citas',
    pacientes: '/medico/pacientes',
    estadisticas: '/medico/estadisticas',
  },

  // Pacientes
  paciente: {
    dashboard: '/paciente/dashboard',
    citas: '/paciente/citas',
    agendarCita: '/paciente/citas/agendar',
    cancelarCita: '/paciente/citas/cancelar',
    historial: '/paciente/historial',
    documentos: '/paciente/documentos',
    favoritos: '/paciente/favoritos',
    perfil: '/paciente/perfil',
  },

  // Citas
  citas: {
    list: '/citas',
    create: '/citas',
    update: '/citas',
    delete: '/citas',
    confirmar: '/citas/confirmar',
    cancelar: '/citas/cancelar',
    getByMedico: '/citasbuscador/new/getcitados',
    save: '/admisiones/new/savecita',
  },

  // Admisiones
  admisiones: {
    list: '/admisiones',
    create: '/admisiones',
    update: '/admisiones',
  },

  // Historia Clínica
  historiaClinica: {
    list: '/historia-clinica',
    create: '/historia-clinica',
    update: '/historia-clinica',
    byPaciente: '/historia-clinica/paciente',
  },

  // Procedimientos
  procedimientos: {
    list: '/procedimientos',
    create: '/procedimientos',
    update: '/procedimientos',
  },

  // Entidades
  entidades: {
    getAll: '/entidades/new/getallcliente',
    create: '/entidades/new/savecliente',
    update: '/entidades/new/updatecliente',
    delete: '/entidades/new/deletecliente',
  }
};
